import { useAutoneTranslation } from '@autone/translations';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../atoms';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

interface AdvancedFiltersFieldSelectProps {
  rowId: string;
}

export const AdvancedFiltersFieldSelect = ({
  rowId,
}: AdvancedFiltersFieldSelectProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch, config } = useAdvancedFiltersContext();

  const { field } = state.conditions[rowId];
  const { fieldOptions } = config;

  const handleUpdateField = (field: string | undefined) => {
    dispatch({
      type: 'PATCH_CONDITION',
      payload: {
        rowId,
        condition: {
          field,
          // always reset value because fields could be incompatible
          value: undefined,
        },
      },
    });
  };

  return (
    <Select value={field} onValueChange={handleUpdateField}>
      <SelectTrigger
        aria-label="Select advanced filter"
        id="select-advanced-filter"
        className="rounded-none border-l-0"
      >
        <SelectValue placeholder={common('advanced-filters.column')} />
      </SelectTrigger>
      <SelectContent data-testId="advanced-filters-column-select-content">
        {Object.entries(fieldOptions).map(([id, translatedDisplayName]) => (
          <SelectItem key={id} value={id}>
            {translatedDisplayName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
